import {Component} from '@angular/core';
import {PilePoilsTranslatePipe} from '@shared/pipes/pilepoils-translate.pipe';

@Component({
  templateUrl: './legal-notice.component.html',
  imports: [
    PilePoilsTranslatePipe
  ],
  styleUrl: './legal-notice.component.scss'
})
export class LegalNoticeComponent {
}
